import { render } from "./branch-list-tree.vue?vue&type=template&id=315d8e74"
import script from "./branch-list-tree.vue?vue&type=script&lang=js"
export * from "./branch-list-tree.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__